import { SiteMapRenderer } from "../../../../content/local/sitemap-renderer.jsx";
import * as React from 'react';
export default {
  SiteMapRenderer,
  React
};